module.exports = __webpack_public_path__ + "media/images/auth_4-12f335f9fd0ecbd364ca1fc53bff495b.jpg";